define('collections/cd_manager',['require','collections/base','models/cd_manager'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/cd_manager");

    return BaseCollection.extend({
        model: Model,
        url: 'cd-managers.json'
    });
});

